import React from "react";
import Chart from "react-apexcharts";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";

export const VisitorLineChart = (props) => {
  const { graphData } = props;
  const data = graphData.map((g) => {
    return g.count;
  });
  const categories = graphData.map((g) => {
    return g.dateSpan;
  });

  const maxVal = () => {
    if (Math.max.apply(null, data) <= 10) return 10;
    else if (Math.max.apply(null, data) <= 20) return 20;
    else if (Math.max.apply(null, data) <= 50) return 50;
    else if (Math.max.apply(null, data) <= 100) return 100;
    else if (Math.max.apply(null, data) <= 250) return 250;
    else return 10;
  };
  const max = maxVal();
  const settings = {
    options: {
      chart: {
        id: "apexchart-example",
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: "zoom",
        },
      },
      grid: {
        show: false,
      },
      xaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        categories,
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        tickAmount: max / (max >= 100 ? 20 : 10),
        min: 0,
        max,
        floating: false,
        showAlways: false,
        decimalsInFloat: undefined,
        labels: {
          show: true,
          align: "right",
          minWidth: 0,
          maxWidth: 160,
          style: {
            colors: [],
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 400,
            cssClass: "apexcharts-yaxis-label",
          },
          offsetX: 0,
          offsetY: 0,
          rotate: 0,
          formatter: (value) => {
            return value;
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.7,
          opacityTo: 0.1,
          stops: [20, 100, 100, 100],
        },
      },
      colors: ["#3f51b5"],
      markers: {
        size: 5,
        colors: ["#fff"],
        strokeColor: "#3f51b5",
        strokeWidth: 3,
      },
    },

    series: [
      {
        name: "",
        data,
      },
    ],
  };
  return (
    <div style={{ width: "100%", textAlign: "left", height: "90%" }}>
      <span className={"expo-title"} style={{ color: "#222" }}>
        <EventLabel2 name="VisitorStats" groupName="Exhibitor.Admin" />
      </span>
      <Chart options={settings.options} series={settings.series} type="area" width={"100%"} height={"100%"} />
    </div>
  );
};
